exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/** Colors */\n/** FlatUI Color Palette\n*\n*\tColor names based on FlatUI: https://flatuicolors.com/\n*/\n/** Acrylic Color Palette\n*\n*\tColor names based on Name that Color: http://chir.ag/projects/name-that-color\n*/\n.loading {\n  padding: 20px 0;\n  text-align: center;\n  font-size: 0.8em;\n  color: #888888; }\n  .loading i {\n    margin: 0 5px;\n    animation-duration: 1s;\n    -webkit-animation-duration: 1s; }\n", ""]);

// exports
